<template>
    <div class="row-container">
        <div v-if="!hideMove" class="move">
            <span @click="$emit('moveUp')" style="font-size: 12px" class="icon icon-sort-up"></span>
            <span @click="$emit('moveDown')" style="font-size: 12px" class="icon icon-sort-down"></span>
        </div>
        <div :style="{width: widths ? getWidthOfProp('name') : '300px', paddingLeft: !hideMove ? '25px' : false}">
            {{this.name}}
        </div>
        <div :style="{width: widths ? getWidthOfProp('technical_name') : '350px'}">
            {{this.technicalName}}
        </div>
        <div :style="{width: widths ? getWidthOfProp('action') : '100px'}" v-html="renderActions()" @click="actionClicked($event)">
        </div>
        <div :style="{width: widths ? getWidthOfProp('description') : ''}">
            {{this.description}}
        </div>
    </div>
</template>

<script>

    import Transformers from "../../../components/tables/Transformers";

    export default {
        components: {},
        props: {
            name: {
                required: true,
                type: String
            },
            technicalName: {
                required: true,
                type: String
            },
            actions: {
                required: false,
                type: Array,
                default: function () {
                    return [];
                }
            },
            description: {
                required: true,
                type: String
            },
            widths: { //column object von adaDatatable
                required: false,
                type: Array
            },
            hideMove:{
                default: true,
                type: Boolean
            }
        },
        data: function () {
            return {}
        },
        name: "InteractionRow",
        mounted() {
        },
        methods: {
            renderActions() {
                return Transformers.actionTransformer(this.actions);
            },
            actionClicked(event) {
                let dataType = event.target.getAttribute('data-type');
                if (dataType === 'delete') {
                    this.$emit('onDelete');
                }
            },
            getWidthOfProp(name){
                return this.widths.find(x => x.propName === name).width;
            }
        }
    }
</script>

<style lang="scss" scoped>

    .row-container {
        //padding: 0 10px;
        width: 100%;
        display: flex;
        flex-direction: row;
        background-color: $oddTableRow;
        border-top: solid 1px $lightGrey;
        height:35px;
        align-items: center;
        position: relative;
    }

    .row-container > div {
        padding: 0 20px;
    }

    .move {
        position: absolute;
        top: -3px;
        left: 3px;
        display: flex;
        flex-flow: column;
        height: 36px;
        justify-content: space-between;
        font-size: 12px;
        color: $grey;
        padding: 4px 3px 1px 3px !important;
        margin-top: 2px;
        cursor: pointer;
    }
</style>